import { render, staticRenderFns } from "./order-return.vue?vue&type=template&id=ef84b7dc&scoped=true&"
import script from "./order-return.vue?vue&type=script&lang=js&"
export * from "./order-return.vue?vue&type=script&lang=js&"
import style0 from "./order-return.vue?vue&type=style&index=0&id=ef84b7dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef84b7dc",
  null
  
)

export default component.exports